const { object, string, number, addMethod } = require('yup');

addMethod(string, 'noInvalidChars', function () {
  return this.test('noInvalidChars', 'Contains invalid character', function (value) {
    const badChars = /[|%"<>@\\]/g;
    const badJS = /javascript:/i;
    if (badChars.test(value) || badJS.test(value)) {
      return this.createError({
        message: 'Contains invalid character',
      });
    }

    return true;
  });
});

const schema = (messages = {}) => object().shape({
  title: string()
    .noInvalidChars()
    .required(messages?.title?.required ?? 'Title cannot be blank'),
  firstName: string()
    .noInvalidChars()
    .required(messages?.firstName?.required ?? 'First Name cannot be blank'),
  lastName: string()
    .noInvalidChars()
    .required(messages?.lastName?.required ?? 'Last Name cannot be blank'),
  email: string()
    .email(messages?.email?.email ?? 'Invalid email address')
    .required(messages?.email?.required ?? 'Email address cannot be blank'),
  jobRole: string()
    .transform((value) => value || undefined)
    .required(messages?.jobRole?.required ?? 'Job Role cannot be blank')
    .oneOf(['Marketing', 'Business', 'Technical'], messages?.jobRole?.invalid ?? 'Invalid Job Role'),
  partnerId: number()
    .transform((val, orig) => (orig === '' ? undefined : val))
    .required(messages?.partnerId?.required ?? 'Customer ID cannot be blank'),
  companyName: string()
    .noInvalidChars()
    .required(messages?.companyName?.required ?? 'Company cannot be blank'),
});

module.exports = schema;
